import cx from 'classnames'
import { FC } from 'react'
import { motionSlide } from 'src/hooks/useAppear'

import { colors } from '../../theme'
import { ActionButtonProps } from '../ActionButton'
import { PictureProps } from '../Picture'
import { RichTextProps } from '../RichText'

import * as SC from './styled'
import { SmallPushVariant } from './types'

export type SmallPushProps = {
  className?: string
  title?: string
  richTextProps?: RichTextProps
  actionButtonProps?: ActionButtonProps
  pictureProps?: PictureProps
  variant?: SmallPushVariant
  color?: string
}

const SmallPush: FC<SmallPushProps> = ({
  className,
  title,
  richTextProps,
  actionButtonProps,
  pictureProps,
  variant = SmallPushVariant.default,
  color = colors.blueLight,
}) => {
  const { motionProps } = motionSlide({})

  return (
    <SC.Container
      className={cx('SmallPush', className)}
      $variant={variant}
      $color={color}
      {...motionProps}
    >
      <SC._Picture {...pictureProps} $variant={variant} />
      <SC.Content $variant={variant}>
        {title && <SC.Title>{title}</SC.Title>}
        {richTextProps && <SC._RichText {...richTextProps} />}
        {actionButtonProps && (
          <SC._ActionButton {...actionButtonProps} iconColor={color} />
        )}
      </SC.Content>
      <SC.Decoration aria-hidden $variant={variant}>
        <SC.Shape />
      </SC.Decoration>
    </SC.Container>
  )
}

export default SmallPush
